module.exports = __webpack_public_path__ + "img/2024big2.a62e9c53.png";